import { Box, Typography } from "@mui/material";
import useColors from "../../../../api/hooks/useColors";
import AdminChip from "./AdminChip";
import AdminSinceTooltip from "./AdminSinceTooltip";

const AdminPermissionsIcon = ({ sincePermissionList }) => {
  const colors = useColors();
  const maxVisibleChips = 4;
  const visiblePermissions =
    sincePermissionList?.length > maxVisibleChips
      ? sincePermissionList.slice(0, maxVisibleChips - 1)
      : sincePermissionList;
  const remainingCount =
    sincePermissionList?.length - visiblePermissions.length;
  const hiddenPermissions = sincePermissionList?.slice(maxVisibleChips - 1);

  return (
    <Box display={"flex"} flexDirection={"row"} gap={1}>
      {visiblePermissions.map((permission, index) => (
        <AdminSinceTooltip key={index} permissions={permission}>
          <Box>
            <AdminChip
              permissionType={permission?.admin_type}
              withLabel={false}
              category={permission?.admin_category}
            />
          </Box>
        </AdminSinceTooltip>
      ))}
      {remainingCount > 0 && (
        <AdminSinceTooltip permissions={hiddenPermissions} isList={true}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              borderRadius: "8px",
              fontSize: "12px",
              border: `0.5px solid ${colors.action_active}`,
              color: colors.text_primary,
              backgroundColor: "transparent",
              padding: "4px 8px",
            }}
          >
            <Typography variant="caption" component="span">
              {`+${remainingCount}`}
            </Typography>
          </Box>
        </AdminSinceTooltip>
      )}
    </Box>
  );
};

export default AdminPermissionsIcon;
